/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureEaApiKeyMaster extends models.ServiceAccountNativeDetailsBaseForAzureEaMaster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureEaApiKeyMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureEaApiKeyMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureEaApiKeyMaster>): ServiceAccountNativeDetailsForAzureEaApiKeyMaster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureEaApiKeyMaster(), model);
        ServiceAccountNativeDetailsForAzureEaApiKeyMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureEaApiKeyMaster>): ServiceAccountNativeDetailsForAzureEaApiKeyMaster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureEaApiKeyMaster.newInstance(<ServiceAccountNativeDetailsForAzureEaApiKeyMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureEaApiKeyMaster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureEaApiKeyMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureEaApiKeyMaster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureEaMaster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureEaApiKeyMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
